export default "__VITE_ASSET__38bd2d48__"